import TieredInterventionCallout from '../TieredInterventionCallout'

export const createShutterList = contentDescription => (
  <TieredInterventionCallout contentDescription={contentDescription} />
)
